var map = {
	"./bird.png": 63,
	"./bird_1.png": 64,
	"./bird_2.png": 65,
	"./bird_3.png": 66,
	"./bird_4.png": 67,
	"./cat.png": 68,
	"./cat_1.png": 69,
	"./cat_2.png": 70,
	"./cat_3.png": 71,
	"./cat_4.png": 72,
	"./dog.png": 73,
	"./dog_1.png": 74,
	"./dog_2.png": 75,
	"./dog_3.png": 76,
	"./dog_4.png": 77,
	"./frog.png": 78,
	"./frog_1.png": 79,
	"./frog_2.png": 80,
	"./frog_3.png": 81,
	"./frog_4.png": 82,
	"./hedgehog.png": 83,
	"./hedgehog_1.png": 84,
	"./hedgehog_2.png": 85,
	"./hedgehog_3.png": 86,
	"./hedgehog_4.png": 87,
	"./rabit.png": 88,
	"./rabit_2.png": 89,
	"./rabit_3.png": 90,
	"./rabit_4.png": 91,
	"./rabit_5.png": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;